// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Table — the data table (.tbl), sortable headers, skeleton + empty rows.
   Owned by the Table primitives (Th / SortHead / SkeletonRows / EmptyRow);
   pages render the raw <table className="tbl"> around them. */
.tbl-wrap {
  overflow-x: auto;
  border: 1px solid var(--border);
  background: var(--surface);
}
/* The wrap scrolls only while the table is wider than it, so this floor decides
   where truncation ends and scrolling begins. 720px is the wrap's own width at a
   1024 viewport (measured 724, with the 216px sidebar that does not collapse
   there): the laptop stays free of scroll, and a narrower screen scrolls the wrap
   instead of squeezing every column into ellipsis and leaving the last one
   unreachable.
   One floor serves every .tbl. A money-heavy table needs ~900px to keep its
   amounts whole at the floor; that wants a .tbl--wide modifier, not a higher
   global floor, which would make the 1024 laptop scroll. */
.tbl-wrap > table.tbl {
  min-width: 720px;
}
/* Fixed layout so columns respect their widths and text truncates, which is the
   reading above the floor. Below it the wrap scrolls and nothing truncates. */
.tbl {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}
.tbl th,
.tbl td {
  overflow: hidden;
}
.tbl th:has(.tip) {
  /* The header tooltip hangs outside the cell. A label wider than a narrow
     column wraps instead of spilling out, which would scroll .tbl-wrap. */
  overflow: visible;
  white-space: normal;
}
/* The tooltip opens below its header and .tbl-wrap clips what overflows, so a
   table with a tooltip header keeps room for it even with one row. */
.tbl-wrap:has(th .tip) {
  min-height: 128px;
}
.tbl th {
  font-family: var(--mono);
  font-size: var(--fs-micro);
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--text-muted);
  font-weight: 500;
  text-align: left;
  padding: 11px var(--row-pad-x);
  border-bottom: 1px solid var(--border);
  white-space: nowrap;
  background: var(--bg-alt);
}
.tbl td {
  padding: var(--row-pad-y) var(--row-pad-x);
  border-bottom: 1px solid var(--border-soft);
  vertical-align: middle;
}
.tbl tbody tr {
  transition: background var(--dur-1) var(--ease);
  cursor: pointer;
}
.tbl tbody tr:hover {
  background: var(--bg-alt);
}
.tbl tbody tr:last-child td {
  border-bottom: 0;
}
.tbl .num {
  font-family: var(--mono);
  font-variant-numeric: tabular-nums;
  text-align: right;
  white-space: nowrap;
}
.tbl__id {
  font-family: var(--mono);
  font-size: var(--fs-meta);
  color: var(--text-secondary);
  letter-spacing: 0.01em;
  white-space: nowrap;
}
.tbl tr[data-urgent='true'] td:first-child {
  box-shadow: inset 3px 0 0 var(--danger);
}
.tbl__primary {
  font-weight: 500;
  color: var(--text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tbl__secondary {
  color: var(--text-muted);
  font-size: var(--fs-meta);
  margin-top: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tbl__id {
  overflow: hidden;
  text-overflow: ellipsis;
}
.tbl__cell-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-size: var(--fs-2xs);
  line-height: 1.35;
}
.tbl-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 11px var(--row-pad-x);
  border-top: 1px solid var(--border);
  font-family: var(--mono);
  font-size: var(--fs-sm);
  color: var(--text-muted);
  letter-spacing: 0.04em;
}
.row--on {
  background: var(--accent-soft);
}
.row--on td:first-child {
  box-shadow: inset 3px 0 0 var(--accent);
}

/* sortable headers */
.tbl th.th-sort {
  position: relative;
  cursor: pointer;
  user-select: none;
}
.tbl th.th-sort:hover {
  color: var(--text);
}
.th-sort__in {
  display: inline-flex;
  width: 100%;
  align-items: center;
  gap: 6px;
  margin: 0;
  padding: 0;
  border: 0;
  background: none;
  color: inherit;
  font: inherit;
  letter-spacing: inherit;
  text-transform: inherit;
  cursor: pointer;
}
.th-sort__in::after {
  /* The whole cell is the hit area, whatever the density padding is. */
  content: '';
  position: absolute;
  inset: 0;
}
.th-sort__in .tip {
  /* Above the hit-area pseudo-element so the tooltip still shows on hover. */
  z-index: 1;
}
.th-sort__in:focus-visible {
  outline: 2px solid var(--signal, var(--accent));
  outline-offset: -2px;
}
.tbl th.th-sort.num .th-sort__in {
  justify-content: flex-end;
}
.th-sort__caret {
  font-family: var(--mono);
  font-size: var(--fs-sm);
  color: var(--accent);
  width: 8px;
  display: inline-block;
  opacity: 0;
  transition: opacity var(--dur-1) var(--ease);
}
.tbl th.th-sort:hover .th-sort__caret {
  opacity: 0.45;
}
.tbl th.th-sort.is-on {
  color: var(--text);
}
.tbl th.th-sort.is-on .th-sort__caret {
  opacity: 1;
}

/* empty row */
.tbl__empty-row td {
  padding: 0 !important;
}
.tbl-empty {
  padding: 34px 16px;
  text-align: center;
}
.tbl-empty__t {
  font-size: var(--fs-note);
  color: var(--text);
  margin-bottom: 4px;
}
/* Retry inside the error row: a text button, because the row is a message and not
   a form. It reads as the accent link it is, without borrowing the weight of a
   page action. */
.tbl-empty__retry {
  background: none;
  border: 0;
  padding: 0;
  font: inherit;
  color: var(--accent);
  cursor: pointer;
  text-decoration: underline;
}

/* loading skeleton (scoped under .page — .skel also exists in ui/Skeleton) */
@keyframes skelpulse {
  0%,
  100% {
    opacity: 0.55;
  }
  50% {
    opacity: 0.9;
  }
}
.page .skel-row td {
  padding: var(--row-pad-y) var(--row-pad-x);
}
.page .skel {
  display: inline-block;
  height: 11px;
  border-radius: 2px;
  background: var(--border-soft);
  animation: skelpulse 1.2s var(--ease-inout) infinite;
}
@media (prefers-reduced-motion: reduce) {
  .page .skel {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/ui/Table/Table.css"],"names":[],"mappings":"AAAA;;8DAE8D;AAC9D;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,0BAA0B;AAC5B;AACA;;;;;;;;2DAQ2D;AAC3D;EACE,gBAAgB;AAClB;AACA;8EAC8E;AAC9E;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE;0EACwE;EACxE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;qEACqE;AACrE;EACE,iBAAiB;AACnB;AACA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;EAChB,8BAA8B;EAC9B,sCAAsC;EACtC,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,0CAA0C;EAC1C,2CAA2C;EAC3C,sBAAsB;AACxB;AACA;EACE,+CAA+C;EAC/C,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;EAC5B,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,uCAAuC;AACzC;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,8BAA8B;EAC9B,mCAAmC;EACnC,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,sBAAsB;AACxB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,uCAAuC;AACzC;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,qEAAqE;EACrE,WAAW;EACX,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,2EAA2E;EAC3E,UAAU;AACZ;AACA;EACE,+CAA+C;EAC/C,oBAAoB;AACtB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,oBAAoB;EACpB,UAAU;EACV,qBAAqB;EACrB,UAAU;EACV,4CAA4C;AAC9C;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;;AAEA,cAAc;AACd;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;;iBAEiB;AACjB;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,oBAAoB;EACpB,eAAe;EACf,0BAA0B;AAC5B;;AAEA,6EAA6E;AAC7E;EACE;;IAEE,aAAa;EACf;EACA;IACE,YAAY;EACd;AACF;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,oDAAoD;AACtD;AACA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Table — the data table (.tbl), sortable headers, skeleton + empty rows.\n   Owned by the Table primitives (Th / SortHead / SkeletonRows / EmptyRow);\n   pages render the raw <table className=\"tbl\"> around them. */\n.tbl-wrap {\n  overflow-x: auto;\n  border: 1px solid var(--border);\n  background: var(--surface);\n}\n/* The wrap scrolls only while the table is wider than it, so this floor decides\n   where truncation ends and scrolling begins. 720px is the wrap's own width at a\n   1024 viewport (measured 724, with the 216px sidebar that does not collapse\n   there): the laptop stays free of scroll, and a narrower screen scrolls the wrap\n   instead of squeezing every column into ellipsis and leaving the last one\n   unreachable.\n   One floor serves every .tbl. A money-heavy table needs ~900px to keep its\n   amounts whole at the floor; that wants a .tbl--wide modifier, not a higher\n   global floor, which would make the 1024 laptop scroll. */\n.tbl-wrap > table.tbl {\n  min-width: 720px;\n}\n/* Fixed layout so columns respect their widths and text truncates, which is the\n   reading above the floor. Below it the wrap scrolls and nothing truncates. */\n.tbl {\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: fixed;\n}\n.tbl th,\n.tbl td {\n  overflow: hidden;\n}\n.tbl th:has(.tip) {\n  /* The header tooltip hangs outside the cell. A label wider than a narrow\n     column wraps instead of spilling out, which would scroll .tbl-wrap. */\n  overflow: visible;\n  white-space: normal;\n}\n/* The tooltip opens below its header and .tbl-wrap clips what overflows, so a\n   table with a tooltip header keeps room for it even with one row. */\n.tbl-wrap:has(th .tip) {\n  min-height: 128px;\n}\n.tbl th {\n  font-family: var(--mono);\n  font-size: var(--fs-micro);\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n  font-weight: 500;\n  text-align: left;\n  padding: 11px var(--row-pad-x);\n  border-bottom: 1px solid var(--border);\n  white-space: nowrap;\n  background: var(--bg-alt);\n}\n.tbl td {\n  padding: var(--row-pad-y) var(--row-pad-x);\n  border-bottom: 1px solid var(--border-soft);\n  vertical-align: middle;\n}\n.tbl tbody tr {\n  transition: background var(--dur-1) var(--ease);\n  cursor: pointer;\n}\n.tbl tbody tr:hover {\n  background: var(--bg-alt);\n}\n.tbl tbody tr:last-child td {\n  border-bottom: 0;\n}\n.tbl .num {\n  font-family: var(--mono);\n  font-variant-numeric: tabular-nums;\n  text-align: right;\n  white-space: nowrap;\n}\n.tbl__id {\n  font-family: var(--mono);\n  font-size: var(--fs-meta);\n  color: var(--text-secondary);\n  letter-spacing: 0.01em;\n  white-space: nowrap;\n}\n.tbl tr[data-urgent='true'] td:first-child {\n  box-shadow: inset 3px 0 0 var(--danger);\n}\n.tbl__primary {\n  font-weight: 500;\n  color: var(--text);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.tbl__secondary {\n  color: var(--text-muted);\n  font-size: var(--fs-meta);\n  margin-top: 2px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.tbl__id {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.tbl__cell-2 {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  font-size: var(--fs-2xs);\n  line-height: 1.35;\n}\n.tbl-foot {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 11px var(--row-pad-x);\n  border-top: 1px solid var(--border);\n  font-family: var(--mono);\n  font-size: var(--fs-sm);\n  color: var(--text-muted);\n  letter-spacing: 0.04em;\n}\n.row--on {\n  background: var(--accent-soft);\n}\n.row--on td:first-child {\n  box-shadow: inset 3px 0 0 var(--accent);\n}\n\n/* sortable headers */\n.tbl th.th-sort {\n  position: relative;\n  cursor: pointer;\n  user-select: none;\n}\n.tbl th.th-sort:hover {\n  color: var(--text);\n}\n.th-sort__in {\n  display: inline-flex;\n  width: 100%;\n  align-items: center;\n  gap: 6px;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  background: none;\n  color: inherit;\n  font: inherit;\n  letter-spacing: inherit;\n  text-transform: inherit;\n  cursor: pointer;\n}\n.th-sort__in::after {\n  /* The whole cell is the hit area, whatever the density padding is. */\n  content: '';\n  position: absolute;\n  inset: 0;\n}\n.th-sort__in .tip {\n  /* Above the hit-area pseudo-element so the tooltip still shows on hover. */\n  z-index: 1;\n}\n.th-sort__in:focus-visible {\n  outline: 2px solid var(--signal, var(--accent));\n  outline-offset: -2px;\n}\n.tbl th.th-sort.num .th-sort__in {\n  justify-content: flex-end;\n}\n.th-sort__caret {\n  font-family: var(--mono);\n  font-size: var(--fs-sm);\n  color: var(--accent);\n  width: 8px;\n  display: inline-block;\n  opacity: 0;\n  transition: opacity var(--dur-1) var(--ease);\n}\n.tbl th.th-sort:hover .th-sort__caret {\n  opacity: 0.45;\n}\n.tbl th.th-sort.is-on {\n  color: var(--text);\n}\n.tbl th.th-sort.is-on .th-sort__caret {\n  opacity: 1;\n}\n\n/* empty row */\n.tbl__empty-row td {\n  padding: 0 !important;\n}\n.tbl-empty {\n  padding: 34px 16px;\n  text-align: center;\n}\n.tbl-empty__t {\n  font-size: var(--fs-note);\n  color: var(--text);\n  margin-bottom: 4px;\n}\n/* Retry inside the error row: a text button, because the row is a message and not\n   a form. It reads as the accent link it is, without borrowing the weight of a\n   page action. */\n.tbl-empty__retry {\n  background: none;\n  border: 0;\n  padding: 0;\n  font: inherit;\n  color: var(--accent);\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n/* loading skeleton (scoped under .page — .skel also exists in ui/Skeleton) */\n@keyframes skelpulse {\n  0%,\n  100% {\n    opacity: 0.55;\n  }\n  50% {\n    opacity: 0.9;\n  }\n}\n.page .skel-row td {\n  padding: var(--row-pad-y) var(--row-pad-x);\n}\n.page .skel {\n  display: inline-block;\n  height: 11px;\n  border-radius: 2px;\n  background: var(--border-soft);\n  animation: skelpulse 1.2s var(--ease-inout) infinite;\n}\n@media (prefers-reduced-motion: reduce) {\n  .page .skel {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
